var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOpen)?_c('v-dialog',{attrs:{"scrollable":"","max-width":"1200"}},[_c('v-card',[[_c('v-toolbar',{attrs:{"dense":"","flat":"","dark":""}},[_c('v-spacer'),_c('v-toolbar-items')],1),_c('v-card-text',{staticStyle:{"min-height":"600px"}},[_c('v-form',[_c('v-container')],1)],1)]],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }